import { actions as user } from "redux/slice/user";
import { actions as app } from "redux/slice/app";

const actions = {
  ...user,
  ...app,
};

export default actions;
